import { render } from "./MissingConnection.vue?vue&type=template&id=5a58b21b"
import script from "./MissingConnection.vue?vue&type=script&lang=js"
export * from "./MissingConnection.vue?vue&type=script&lang=js"
script.render = render

export default script